module.exports = __webpack_public_path__ + "img/monogram-color.ea38490.png";